import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LazyLoadEvent } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs/operators';
import { AppComponentBase, PagedTableSummary } from 'src/app/app-component-base';
import {
    MonitorMaquinaBellcoErrorResponse,
    MonitorMaquinaBellcoResponse,
    MonitorMaquinasBellcoServiceProxy
} from '../../../../shared/service-proxies/service-proxies';
import { DateTimeService } from '../../../../shared/services/datetime.service';
import { Router } from '@angular/router';
import { AppConsts } from '../../../../shared/AppConsts';

@Component({
    selector: 'app-monitormaquinasbellco',
    templateUrl: 'monitormaquinasbellco.component.html'
})
export class MonitorMaquinasBellcoComponent extends AppComponentBase implements OnInit {

    form: FormGroup;
    loading = false;

    permissions: any;

    colsMaquinas: any[];
    colsErrores: any[];

    maquinasList: MonitorMaquinaBellcoResponse[] = [];
    erroresList: MonitorMaquinaBellcoErrorResponse[] = [];

    mostrarMonitor = false;
    doTemblar = false;
    doAlertar = false;

    intervalDesconectadas = null;
    intervalErrores = null;

    tiempoMonitoreo = 30000;

    constructor(
        injector: Injector,
        private service: MonitorMaquinasBellcoServiceProxy,
        private datetimeService: DateTimeService
    ) {
        super(injector);

        const self = this;
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.form.controls;
    }

    get dtService() {
        return this.datetimeService;
    }

    ngOnInit() {
        const self = this;

        self.colsMaquinas = [
            { field: 'equipo', header: this.l('Procesos.MonitorMaquinasBellco.Equipo.Col'), isActive: true },
            { field: 'etiqueta', header: this.l('Procesos.MonitorMaquinasBellco.Etiqueta.Col'), isActive: true },
            { field: 'sala', header: this.l('Procesos.MonitorMaquinasBellco.Sala.Col'), isActive: true },
            { field: 'ultimaLectura', header: this.l('Procesos.MonitorMaquinasBellco.Estatus.Col'), isActive: true }
        ];

        self.colsErrores = [
            { field: 'fecha', header: this.l('Procesos.MonitorMaquinasBellco.Fecha.Col'), isActive: true },
            { field: 'equipo', header: this.l('Procesos.MonitorMaquinasBellco.Equipo.Col'), isActive: true },
            { field: 'etiqueta', header: this.l('Procesos.MonitorMaquinasBellco.Etiqueta.Col'), isActive: true },
            { field: 'sala', header: this.l('Procesos.MonitorMaquinasBellco.Sala.Col'), isActive: true },
            { field: 'mensaje', header: this.l('Procesos.MonitorMaquinasBellco.Mensaje.Col'), isActive: true }
        ];

        self.permissions = {
            monitor: self.permission.isGranted('Procesos.MonitorMaquiansBellco')
        };

        if (self.permissions.monitor) {

            self.getMaquinasDesconectadas();
            self.getErrores();

            self.intervalDesconectadas = setInterval(function () {
                self.getMaquinasDesconectadas();
            }, self.tiempoMonitoreo);

            self.intervalErrores = setInterval(function () {
                self.getErrores();
            }, self.tiempoMonitoreo);

            self.mostrarMonitor = false;
        } else {
            self.intervalDesconectadas = null;
            self.intervalErrores = null;
        }
    }

    detenerMonitor(): void {
        const self = this;

        // alert('Terminando monitor de máquinas');

        self.intervalDesconectadas = null;
        self.intervalErrores = null;
    }

    getMaquinasDesconectadas(): void {
        const self = this;

        self.service.getMonitorMaquinasBellcoList()
            .pipe(finalize(() => {
            }))
            .subscribe(data => {

                if (data.length > 0
                    && data.length !== self.maquinasList.length
                    && !self.doTemblar) {

                    self.doTemblar = true;
                    self.doAlertar = true;

                    // A los 3 segundos dejará de vibrar(temblar)
                    setTimeout(function () {
                        self.doTemblar = false;
                    }, 3000);
                }

                self.maquinasList = data;
            });
    }

    getErrores(): void {
        const self = this;

        self.service.getMonitorMaquinasBellcoErroresList()
            .pipe(finalize(() => {
            }))
            .subscribe(data => {
                self.erroresList = data;
            });
    }

    mostrar(): void {
        const self = this;
        self.mostrarMonitor = true;
        self.doAlertar = false;
    }

    ocultar(): void {
        this.mostrarMonitor = false;
    }
}
